import React from 'react'
import ResetPassword from 'src/app/ResetPassword/ResetPassword'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { resetPasswordRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const ResetPasswordAppRoute: AppRoute = {
  id: AppLocation.ResetPassword,
  routeProps: resetPasswordRouteProps,
  component: <ResetPassword />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default ResetPasswordAppRoute
